import config from '../config';

/**
 * Estado público del proveedor LLM (#1722). `fetch` PLANO, a propósito: `apiClient` dispara los
 * listeners globales (términos 451, cuenta inactiva 403, prueba vencida) que redirigen, y una
 * página pública —o un banner que se pinta en /login— no debe redirigir jamás.
 *
 * Cualquier fallo (red, no-200, JSON raro, status desconocido) es `unknown`: nunca se inventa
 * un «operativo» a partir de la ausencia de datos.
 */

const VALID_STATUSES = ['operational', 'degraded', 'down', 'unknown'];
const TIMEOUT_MS = 10000;

export const UNKNOWN_STATUS = Object.freeze({
  status: 'unknown',
  since: null,
  updatedAt: null,
  provider: null,
  incidents: [],
});

const asIso = (v) => (typeof v === 'string' && !Number.isNaN(Date.parse(v)) ? v : null);

export async function fetchProviderStatus() {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), TIMEOUT_MS);
  try {
    const res = await fetch(`${config.apiUrl}/api/status`, {
      credentials: 'omit',
      signal: controller.signal,
    });
    if (!res.ok) return UNKNOWN_STATUS;
    const body = await res.json();
    if (!body || !VALID_STATUSES.includes(body.status)) return UNKNOWN_STATUS;
    return {
      status: body.status,
      since: asIso(body.since),
      updatedAt: asIso(body.updatedAt),
      provider: typeof body.provider === 'string' ? body.provider : null,
      incidents: Array.isArray(body.incidents)
        ? body.incidents
            .filter((i) => i && asIso(i.startedAt))
            .map((i) => ({
              peakStatus: i.peakStatus === 'down' ? 'down' : 'degraded',
              startedAt: i.startedAt,
              endedAt: asIso(i.endedAt),
            }))
        : [],
    };
  } catch {
    return UNKNOWN_STATUS;
  } finally {
    clearTimeout(timer);
  }
}
